import React from 'react';
import YouTube from 'react-youtube';

const YouTubeVideo = ({ videoId }) => {
  const opts = {
    height: '390',
    width: '640',
    playerVars: {
      autoplay: 1, // Autoplay the video on load
    },
  };

  const handleReady = (event) => {
    event.target.pauseVideo();  // You can auto-pause the video on load
  };

  return (
    <iframe
      width={"560"}
      height={"315"}
      src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      title="Embedded YouTube Video"
    />
  )
  // <YouTube videoId={videoId} opts={opts} onReady={handleReady} />;
};

export default YouTubeVideo;
